import Isotope from "isotope-layout";
import imagesLoaded from 'imagesloaded';

const IsotopeMasonryGridInit = function () {

    const $isos = document.querySelectorAll(".isotope-masonry-grid");

    imagesLoaded(document.querySelectorAll('.isotope-masonry-grid-item__image'), function (instance) {
        if ($isos) {
            $isos.forEach($iso => {

                const iso = new Isotope($iso, {
                    itemSelector: ".isotope-masonry-grid-item",
                    // masonry: {
                    //     columnWidth: 200,
                    // },
                    layoutMode: 'fitRows'
                });

            });
        }
    });

}

export default IsotopeMasonryGridInit;
